// TinyGlobal — platform component relation map
// Canvas: 1100 x 730  |  NODE_W = 130  NODE_H = 36

export const CATEGORIES = {
  external:      { color: "#f97316", bg: "#fff7ed", label: "External / Input" },
  orchestration: { color: "#3b82f6", bg: "#eff6ff", label: "Core Orchestration" },
  transaction:   { color: "#eab308", bg: "#fefce8", label: "Transaction Records" },
  fulfillment:   { color: "#10b981", bg: "#f0fdf4", label: "System / Fulfilment" },
  gate:          { color: "#ef4444", bg: "#fef2f2", label: "Gate / Decision" },
  infra:         { color: "#8b5cf6", bg: "#f5f3ff", label: "Infrastructure" },
  role:          { color: "#06b6d4", bg: "#ecfeff", label: "User Role" },
};

export const EDGE_TYPES = {
  request:       { color: "#3b82f6", label: "→ request",      dash: "" },
  notifies:      { color: "#10b981", label: "↑ notifies",     dash: "" },
  approval_gate: { color: "#f97316", label: "⊣ approval gate", dash: "" },
  reads_syncs:   { color: "#94a3b8", label: "⇢ reads/syncs",  dash: "5 3" },
};

export const DEFAULT_NODES = [
  // Col 1 — external
  { id: "client",        label: "Client Portal",      category: "external",      x: 20,  y: 80  },
  { id: "suppliers",     label: "Suppliers",           category: "external",      x: 20,  y: 280 },
  // Col 2 — transactions
  { id: "po",            label: "Purchase Orders",     category: "transaction",   x: 210, y: 180 },
  { id: "payments",      label: "Payments / Square",   category: "transaction",   x: 210, y: 380 },
  // Col 3 — operations
  { id: "operator",      label: "Operator Dashboard",  category: "orchestration", x: 400, y: 60  },
  { id: "inbound",       label: "Inbound Receiving",   category: "transaction",   x: 400, y: 260 },
  { id: "customs",       label: "Customs / ATT",       category: "gate",          x: 400, y: 460 },
  // Col 4 — storage
  { id: "inventory",     label: "Inventory",           category: "fulfillment",   x: 590, y: 160 },
  { id: "warehouses",    label: "Warehouses",          category: "fulfillment",   x: 590, y: 370 },
  { id: "erp",           label: "ERP Sync",            category: "infra",         x: 590, y: 530 },
  // Col 5 — integration
  { id: "notifications", label: "Notification Hub",    category: "fulfillment",   x: 780, y: 80  },
  { id: "integrations",  label: "Integration Hub",     category: "infra",         x: 780, y: 300 },
  { id: "firestore",     label: "Firestore",           category: "infra",         x: 780, y: 490 },
  // Col 6 — data
  { id: "supabase",      label: "Supabase",            category: "infra",         x: 960, y: 300 },

  // Row — user roles (pill nodes, bottom strip)
  { id: "role_superadmin", label: "Super Admin",  category: "role", x: 20,  y: 670 },
  { id: "role_tenant",     label: "Tenant",        category: "role", x: 185, y: 670 },
  { id: "role_client",     label: "Client",        category: "role", x: 350, y: 670 },
  { id: "role_operator",   label: "Operator",      category: "role", x: 515, y: 670 },
  { id: "role_3pl",        label: "3PL Partner",   category: "role", x: 680, y: 670 },
  { id: "role_vendor",     label: "Vendor",        category: "role", x: 845, y: 670 },
];

export const DEFAULT_EDGES = [
  { id: "e1",  from: "suppliers",     to: "po",           type: "request",       label: "Submits vendor order request" },
  { id: "e2",  from: "po",            to: "operator",     type: "approval_gate", label: "Routes PO for approval" },
  { id: "e3",  from: "po",            to: "inbound",      type: "request",       label: "Creates inbound receipt record" },
  { id: "e4",  from: "operator",      to: "inbound",      type: "request",       label: "Confirms goods arrival" },
  { id: "e5",  from: "inbound",       to: "inventory",    type: "notifies",      label: "Updates stock on receipt" },
  { id: "e6",  from: "inbound",       to: "po",           type: "notifies",      label: "Marks PO as received" },
  { id: "e7",  from: "client",        to: "inventory",    type: "reads_syncs",   label: "Views available stock" },
  { id: "e8",  from: "client",        to: "payments",     type: "request",       label: "Initiates invoice payment" },
  { id: "e9",  from: "customs",       to: "operator",     type: "approval_gate", label: "Flags compliance gate" },
  { id: "e10", from: "inventory",     to: "notifications",type: "notifies",      label: "Fires low-stock alert" },
  { id: "e11", from: "payments",      to: "supabase",     type: "reads_syncs",   label: "Syncs invoice to Supabase" },
  { id: "e12", from: "erp",           to: "supabase",     type: "reads_syncs",   label: "Reads/writes master data" },
  { id: "e13", from: "integrations",  to: "erp",          type: "request",       label: "Pushes EDI/AS2 data" },
  { id: "e14", from: "warehouses",    to: "inventory",    type: "notifies",      label: "Updates bin locations" },
  { id: "e15", from: "notifications", to: "client",       type: "notifies",      label: "Pushes status alerts" },
  { id: "e16", from: "operator",      to: "firestore",    type: "reads_syncs",   label: "Reads tenant config" },
  { id: "e17", from: "inventory",     to: "warehouses",   type: "reads_syncs",   label: "Assigns bin location" },
  { id: "e18", from: "payments",      to: "firestore",    type: "reads_syncs",   label: "Logs payment record" },

  // Role → component edges
  { id: "r1",  from: "role_superadmin", to: "operator",   type: "reads_syncs",   label: "Full platform oversight" },
  { id: "r2",  from: "role_superadmin", to: "supabase",   type: "reads_syncs",   label: "Direct DB access" },
  { id: "r3",  from: "role_tenant",     to: "client",     type: "reads_syncs",   label: "Owns client accounts" },
  { id: "r4",  from: "role_tenant",     to: "payments",   type: "request",       label: "Pays subscription invoices" },
  { id: "r5",  from: "role_client",     to: "client",     type: "request",       label: "Logs into client portal" },
  { id: "r6",  from: "role_client",     to: "customs",    type: "request",       label: "Submits ATT applications" },
  { id: "r7",  from: "role_operator",   to: "operator",   type: "request",       label: "Manages daily ops" },
  { id: "r8",  from: "role_operator",   to: "inbound",    type: "request",       label: "Receives inbound goods" },
  { id: "r9",  from: "role_operator",   to: "customs",    type: "approval_gate", label: "Approves customs entries" },
  { id: "r10", from: "role_3pl",        to: "inbound",    type: "request",       label: "Processes shipments" },
  { id: "r11", from: "role_3pl",        to: "warehouses", type: "request",       label: "Manages warehouse bins" },
  { id: "r12", from: "role_vendor",     to: "suppliers",  type: "request",       label: "Updates vendor profile" },
  { id: "r13", from: "role_vendor",     to: "po",         type: "reads_syncs",   label: "Receives PO updates" },
];
